import { useLDClient } from 'launchdarkly-vue-client-sdk'

interface FeatureFlag {
  key: string
  value: boolean
}

type FeatureFlagKeys = 'faq' | 'onboarding' | 'signup' | 'sso' | 'welcomeScreen' | 'newPricing' |
  'bsd' | 'invoiceServices' | 'prices' | 'wpMetabaseDashboard' | 'wrMetabaseDashboard' |
  'wrRoundEnabled' | 'canUpdateCollectCollectedContainer' | 'legacyDashboard' | 'guidedTour' | 'addProvider'

// Key corresponds to LaunchDarkly feature flag key
export const featureFlags = reactive<Record<FeatureFlagKeys, FeatureFlag>>({
  faq: { key: 'ff_faq', value: false },
  onboarding: { key: 'ff_onboarding', value: false },
  signup: { key: 'ff_signup', value: false },
  sso: { key: 'ff_enable_sso', value: false },
  welcomeScreen: { key: 'welcome-screen', value: false },
  newPricing: { key: 'new-pricing', value: false },
  bsd: { key: 'ff_bsd_signature_and_creation_enabled', value: false },
  invoiceServices: { key: 'ff_invoice_services', value: false },
  prices: { key: 'ff_prices', value: false },
  wpMetabaseDashboard: { key: 'ff_wp_metabase_dashboard', value: false },
  wrMetabaseDashboard: { key: 'ff_wr_metabase_dashboard', value: false },
  wrRoundEnabled: { key: 'ff_wr_round_enabled', value: false },
  canUpdateCollectCollectedContainer: { key: 'ff_can_update_collect_collected_container', value: false },
  legacyDashboard: { key: 'ff_legacy_dashboard', value: false },
  guidedTour: { key: 'ff_guided_tour', value: false },
  addProvider: { key: 'ff_add_recycler', value: false },
})

// If your flag remains false after enabling it, check if SDKs using Client-side ID in the flag settings
// TODO: values here are only evaluated when the app is mounted, no stream are open so variables arent reactive
export function useFeatureFlag() {
  const ldClient = useLDClient()

  async function initLaunchDarkly() {
    await ldClient.waitForInitialization()

    for (const [key, value] of Object.entries(featureFlags) as [FeatureFlagKeys, FeatureFlag][]) {
      featureFlags[key].value = ldClient.variation(value.key, false)
    }
  }

  return { initLaunchDarkly }
}
